import React, { Component } from "react";
import styled from "styled-components";

import { themeColors } from "../../react/sharedStyles";

const AI_ICON = (
    <svg width="17" height="17" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.98582 3.3706L7.33201 8.33201L2.3706 9.98582C1.87647 10.1505 1.87647 10.8495 2.3706 11.0142L7.33201 12.668L8.98582 17.6294C9.15053 18.1235 9.84947 18.1235 10.0142 17.6294L11.668 12.668L16.6294 11.0142C17.1235 10.8495 17.1235 10.1505 16.6294 9.98582L11.668 8.33201L10.0142 3.3706C9.84947 2.87647 9.15053 2.87647 8.98582 3.3706Z"
            fill="white" />
        <path
            d="M17.2103 14.1957L16.0704 17.0125L13.1929 18.2102C12.9357 18.3172 12.9357 18.6828 13.1929 18.7898L16.0704 19.9875L17.2103 22.8043C17.3159 23.0652 17.6841 23.0652 17.7897 22.8043L18.9296 19.9875L21.8071 18.7898C22.0643 18.6828 22.0643 18.3172 21.8071 18.2102L18.9296 17.0125L17.7897 14.1957C17.6841 13.9348 17.3159 13.9348 17.2103 14.1957Z"
            fill="white" />
    </svg>
);

const AiButton = styled.div`
    background: ${themeColors.aiColor};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
`;

export function AiIcon({ size = 24, contained = false, square = false, iconColor = "white", onClick, style = {} }) {
    let svg = (
        <svg className="ai-icon" width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.98582 3.3706L7.33201 8.33201L2.3706 9.98582C1.87647 10.1505 1.87647 10.8495 2.3706 11.0142L7.33201 12.668L8.98582 17.6294C9.15053 18.1235 9.84947 18.1235 10.0142 17.6294L11.668 12.668L16.6294 11.0142C17.1235 10.8495 17.1235 10.1505 16.6294 9.98582L11.668 8.33201L10.0142 3.3706C9.84947 2.87647 9.15053 2.87647 8.98582 3.3706Z"
                fill={iconColor} />
            <path
                d="M17.2103 14.1957L16.0704 17.0125L13.1929 18.2102C12.9357 18.3172 12.9357 18.6828 13.1929 18.7898L16.0704 19.9875L17.2103 22.8043C17.3159 23.0652 17.6841 23.0652 17.7897 22.8043L18.9296 19.9875L21.8071 18.7898C22.0643 18.6828 22.0643 18.3172 21.8071 18.2102L18.9296 17.0125L17.7897 14.1957C17.6841 13.9348 17.3159 13.9348 17.2103 14.1957Z"
                fill={iconColor} />
        </svg>
    );

    if (contained) {
        return (
            <AiButton onClick={onClick} style={{ width: size * 1.5, height: size * 1.5, ...style }}>{svg}</AiButton>
        );
    } else if (square) {
        return (
            <AiButton onClick={onClick} style={{ width: size, height: size, borderRadius: 0, ...style }}>{svg}</AiButton>
        );
    } else {
        return svg;
    }
}

const Container = styled.div`
    background: ${themeColors.aiColor};
    border-radius: 50%;
    width: 26px !important;
    height: 26px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor pointer;
`;

export class SlideAiButton extends Component {
    render() {
        const { onClick } = this.props;
        return (
            <Container onClick={onClick}>
                {AI_ICON}
            </Container>
        );
    }
}

